interface Props {
  style?: React.CSSProperties
  className?: string
}

export function CrossIcon({ style, className = '' }: Props) {
  return (
    <i className={`icon ${className}`} style={style}>
      <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="32" height="32" rx="16" fill="#F83F1A"/>
        <g clipPath="url(#clip0_5003_4386)">
          <path d="M22.8002 10.21C22.4102 9.81997 21.7802 9.81997 21.3902 10.21L16.5002 15.09L11.6102 10.2C11.2202 9.80997 10.5902 9.80997 10.2002 10.2C9.81021 10.59 9.81021 11.22 10.2002 11.61L15.0902 16.5L10.2002 21.39C9.81021 21.78 9.81021 22.41 10.2002 22.8C10.5902 23.19 11.2202 23.19 11.6102 22.8L16.5002 17.91L21.3902 22.8C21.7802 23.19 22.4102 23.19 22.8002 22.8C23.1902 22.41 23.1902 21.78 22.8002 21.39L17.9102 16.5L22.8002 11.61C23.1802 11.23 23.1802 10.59 22.8002 10.21Z" fill="white"/>
        </g>
        <defs>
          <clipPath id="clip0_5003_4386">
            <rect width="24" height="24" fill="white" transform="translate(4.5 4.5)"/>
          </clipPath>
        </defs>
      </svg>
    </i>
  )
}
